import { render } from "./ExerciseGreedy.vue?vue&type=template&id=43d08610"
import script from "./ExerciseGreedy.vue?vue&type=script&lang=js"
export * from "./ExerciseGreedy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__